import React, { useEffect, useState, useContext } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Icon_finalOffer from "../../assets/svg/EPL_think_svg/offerGif.gif";
import ReverifyIcon from "../../assets/images/EPL_think_images/reverifyIcon.png";
import topBanner from "../../assets/svg/EPL_think_svg/banner2new.png";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";

import LoanSummaryTextItem from "../loan-agreement/_styles/EPL_LoanSummaryTextItem";
import Text from "../loan-agreement/_styles/EPL_Text";
import Button from "../../components/core/EPL_Button_Think";
import { LoanSummaryWrapper } from "../loan-summary/_styles/LoanSummaryWrapper";
import { GET_CUSTOMER_DETAILS } from "../../Config";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isStageLogin } from "../../shared/validations/StageLogin";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const LoanSummary = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [totalLoanAmount, setTotalLoanAmount] = useState(Number(170000));
  const [emiAmount, setEmiAmount] = useState(Number(29000));
  const [processingFee, setProcessingFee] = useState(Number(1000));
  const [insuranceAmount, setInsuranceAmount] = useState(Number(1500));
  const [tenure, setTenure] = useState(12);
  const otpWaitTime = "00:10";
  const [interestRate, setInterestRate] = useState(12);
  const [showEmailOTPModal, setShowEmailOTPModal] = useState();
  const [oldTime, setOldTime] = useState(otpWaitTime);
  const [timer, setTimer] = useState(otpWaitTime);
  const [load, setLoad] = useState();
  const [otp1, setOTP1] = useState();
  const [otp2, setOTP2] = useState();
  const [otp3, setOTP3] = useState();
  const [otp4, setOTP4] = useState();
  const [otp5, setOTP5] = useState();
  const [otp6, setOTP6] = useState();
  const [otpSent, setOtpSent] = useState(false);
  const [resumeTimer, setResumeTimer] = useState(false);
  const [modal, setModal] = useState("");
  const [showTimer, setShowTimer] = useState(false);
  const [resendOtpButtonDisabled, setResjendOtpButtonDisabled] = useState(true);
  // const [emiStartDate, setEmiStartDate] = useState("05/09/2023");

  const [mobNum, setMobNum] = useState("");
  const [ischecked, setIsChecked] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("LoanSummary customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    } else {
      // console.log("LoanSummary Ouch customerDetails ", location);
    }
  }, [customerDetails]);
  function convertDate(date_str) {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let temp_date = date_str.split("/");
    return (
      temp_date[0] + " " + months[Number(temp_date[1]) - 1] + " " + temp_date[2]
    );
  }

  function appendRupee(x) {
    const converted = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 21,
      style: "currency",
      currency: "INR",
    }).format(x);
    return converted;
  }

  function formatDate(inputDate) {
    const parts = inputDate.split("-");
    if (parts.length !== 3) {
      return "00/00/0000";
    }

    const year = parts[0];
    const month = parts[1];
    const day = parts[2];

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  const [existingLoanBalance, setExistingLoanBalance] = useState();
  const [oldLoanAccountNumber, setOldLoanAccountNumber] = useState();

  useEffect(() => {

    isStageLogin(   
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    moengage.track_event("congrats", {
      "journey name": customerDetails?.source,
      disbursementScreen: "reached",
    });

    if(customerDetails?.lob || customerDetails?.offer_type?.startsWith("ABCDPA")){
      window.fbq('track', 'Disbursement', {value: 0.00, currency: 'USD'});
      window.gtag_report();
    }
    
    if (customerDetails.source === "upsell") {
      setExistingLoanBalance(
        parseInt(customerDetails?.Data?.old_loan_amount) || 0
      );
      setOldLoanAccountNumber(customerDetails?.Data?.old_loan_account_number);
      // setTotalLoanAmountForUpsell(customerDetails?.Data?.old_loan_amount + customerDetails?.Data?.max_topup)
    }
    // window.scrollTo(0, 0);
  }, []);

  // useEffect(async () => {
  //   await GetCustomerDetails(
  //     customerDetails.application_form_number,
  //     customerDetails.source,
  //     customerDetails,
  //     setCustomerDetails
  //   );
  //   console.log("Called GetCustomerDetails --- LoanSummary");
  //   console.log(customerDetails);
  // }, []);

  return (
    <>
      <AfterLoginLayoutWrapper>
        <LoanSummaryWrapper className="first-child">
          <ShimmerPlaceholder
            height="9em"
            width="9em"
            marginTop="-1.5em"
            visible={showShimmer}
          />
          <div style={{ width: "125%" }}>
            <a
              href={
                customerDetails?.source === "upsell"
                  ? "https://oneapp.abfldirect.com/aucc/index?dsa_hash=729815e6fe26685bc4258695f676b3e4e86e87bd64db895fe07dffcb8e1befee"
                  : "https://oneapp.abfldirect.com/aucc/index?dsa_hash=e4ff86c84d7e64c7daa7521311cef46b01f37955770561755cb308e74b7953a9"
              }
            >
              <img
                style={{
                  display: showShimmer ? "none" : "",
                  height: "120px",
                  width: "-webkit-fill-available",
                }}
                src={topBanner}
              />
            </a>
          </div>
          <ShimmerPlaceholder
            height="2.5em"
            marginTop="1em"
            width="12em"
            visible={showShimmer}
          />
          <Title
            text={customerDetails?.stage === "DISBURSEMENT_REVERIFY"?`Application Under Review`:`Congrats!`}
            visible={!showShimmer}
            clickable={false}
            style={{
              fontSize: "30px",
            }}
          />

          <ShimmerPlaceholder
            height="2.75em"
            marginTop="-2em"
            visible={showShimmer}
          />
          <div
            style={{
              fontSize: "18px",
              lineHeight: "1.1em",
              textAlign: "center",
            }}
          >
            {customerDetails?.stage === "DISBURSEMENT_REVERIFY" ? 
            <>
                Your employment verification is pending. Please send your <span style={{fontWeight:"bold"}}>latest salary slip</span> and <span style={{fontWeight:"bold"}}>office address</span> to{" "} 
                {customerDetails?.source === "epl"?
                <a
                    href="mailto:Care.digitalfinance@adityabirlacapital.com"
                    style={{backgroundColor: "none", color:"#5D90F3", textDecoration:"none"}}
                >
                    Care.digitalfinance@adityabirlacapital.com
                </a>:
                <a
                  href="mailto:Care.digitalfinance@adityabirlacapital.com"
                  style={{backgroundColor: "none", color:"#5D90F3", textDecoration:"none"}}
                >
                    abfl.upsell@adityabirlacapital.com
                </a>
                }
                {" "}with the subject line "DR Verification - {customerDetails?.application_form_number}". Your loan application will be cancelled if documents are not shared within <span style={{fontWeight:"bold"}}>48 hours</span>. Funds will be released upon positive verification. If verification is unsatisfactory, your loan application will be cancelled.
            </>
            :
            <>
              Your{" "}
              {customerDetails?.source === "upsell" ? "top-up " : "Personal "}{" "}
              Loan of{" "}
              <span style={{ color: "#CB4334", fontWeight: "500" }}>
                {appendRupee(customerDetails?.Data?.cust_accepted_loan_amount)}
              </span>{" "}
              {customerDetails?.stage === "DISBURSEMENT_REVERIFY" ? "is under review for disbursal. Amount will be credited in your bank account post successful verification." : "is ready for disbursal. Amount will be credited in your bank account."}
            </>
          }

          </div>
          {/* <SubTitle
              text={
                "Your Personal Loan of " +
                appendRupee(customerDetails?.Data?.cust_accepted_loan_amount) +
                " is ready for disbursal. Amount will be credited in your bank account"
              }
              visible={!showShimmer}
              clickable={false}
              style={{
                fontSize: "20px",
              }}
            /> */}
          {/* <ShimmerPlaceholder
              height="2.5em"
              width="9em"
              visible={showShimmer}
            /> */}
          {/* <Title
              text={appendRupee(
                customerDetails?.Data?.cust_accepted_loan_amount
              )}
              visible={!showShimmer}
              clickable={false}
            /> */}

          <ShimmerPlaceholder
            height="9em"
            width="9em"
            marginTop="-1.5em"
            visible={showShimmer}
          />
          <img
            style={{ display: showShimmer ? "none" : "", height: "140px" }}
            src={customerDetails?.stage === "DISBURSEMENT_REVERIFY"?ReverifyIcon:Icon_finalOffer}
          />
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                height="15em"
                width="22em"
                marginTop="-0.5em"
                visible={showShimmer}
              />
            </>
          ) : (
            <>
              <div className="summary-container">
                <div className="summary-box">
                  <div className="summary-box-inside">
                    <Text
                      text="Approved Loan Summary"
                      id="lsp-summary-title"
                      size="h5"
                    />
                    {customerDetails.source === "upsell" ? (
                      <div id="lsp-approved-summary-detail">
                        <LoanSummaryTextItem
                          title={"Existing Loan Balance"}
                          value={appendRupee(
                            parseInt(customerDetails?.Data?.old_loan_amount) ||
                              0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Top up Loan Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_loan_amount
                            ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Total Loan Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_loan_amount
                            ) +
                              parseInt(
                                customerDetails?.Data?.old_loan_amount
                              ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"New Monthly EMI Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_emi
                            ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Fees & Charges"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.processing_fees_amount
                            ) +
                              parseInt(
                                customerDetails?.Data?.foreclosure_amount
                              ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Disbursed Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_loan_amount
                            ) -
                              parseInt(
                                customerDetails?.Data?.processing_fees_amount
                              ) -
                              parseInt(
                                customerDetails?.Data?.foreclosure_amount
                              ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Application no."}
                          value={customerDetails?.application_form_number}
                        />
                        <LoanSummaryTextItem
                          title={"New Loan Tenure"}
                          value={`${
                            customerDetails?.Data?.tenure === "None"
                              ? "0"
                              : customerDetails?.Data?.tenure
                          } Months`}
                        />
                        <LoanSummaryTextItem
                          title={"New Interest Rate"}
                          value={`${
                            customerDetails?.Data?.roi === "None"
                              ? "0"
                              : customerDetails?.Data?.roi
                          }%`}
                        />
                        {customerDetails?.Data?.stage === "DISBURSEMENT_REVERIFY" ? <></> :
                          <LoanSummaryTextItem
                            title={"EMI starts from"}
                            value={convertDate(
                              formatDate(customerDetails?.Data?.emi_date)
                            )}
                          />
                        }
                      </div>
                    ) : (
                      <div id="lsp-approved-summary-detail">
                        <LoanSummaryTextItem
                          title={"Loan Amount"}
                          value={appendRupee(
                            customerDetails?.Data?.cust_accepted_loan_amount
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"EMI Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_emi
                            ) || 0
                          )}
                        />
                        {customerDetails?.Data?.cust_ins_choice == "YES" && customerDetails?.source == "epl"? (
                          <LoanSummaryTextItem
                            title={"Processing Fees & Charges"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.processing_fees_amount
                              ) +
                                parseInt(
                                  customerDetails?.Data?.emi_protect_ins
                                ) +
                                parseInt(
                                  customerDetails?.Data?.accident_coverage_ins
                                ) || 0
                            )}
                          />
                        ) : (
                          <LoanSummaryTextItem
                            title={"Processing Fees & Charges"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.processing_fees_amount
                              ) || 0
                            )}
                          />
                        )}
                        <LoanSummaryTextItem
                          title={"Application no."}
                          value={customerDetails.application_form_number}
                        />
                        {/* <LoanSummaryTextItem
                        title={"Insurance Amount"}
                        value={appendRupee(insuranceAmount)}
                      /> */}
                        <LoanSummaryTextItem
                          title={"Loan Tenure"}
                          value={`${
                            customerDetails?.Data?.tenure === "None"
                              ? "0"
                              : customerDetails?.Data?.tenure
                          } Months`}
                        />
                        <LoanSummaryTextItem
                          title={"Interest Rate"}
                          value={`${
                            customerDetails?.Data?.roi === "None"
                              ? "0"
                              : customerDetails?.Data?.roi
                          }% p.a.`}
                        />
                        {customerDetails?.Data?.stage == "DISBURSEMENT_REVERIFY" ? <></> :
                          <LoanSummaryTextItem
                            title={"EMI starts from"}
                            value={convertDate(
                              formatDate(customerDetails?.Data?.emi_date)
                            )}
                          />
                        }
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="bottomDiv">
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  height="3em"
                  width="17em"
                  marginTop="-0.5em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="2.5em"
                  width="8em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                <div className="terms-and-conditions">
                  {customerDetails?.source === "upsell"
                    ? "Loan Disbursal for most cases happens within 15 mins of successful completion of journey at any time of the day. For HDFC bank account holders, loan disbursal will happen within 15 mins provided the journey is completed between 8am-10pm on all days, otherwise the loan amount will be credited on the next day."
                    : customerDetails?.Data?.stage === "DISBURSEMENT_REVERIFY" ? "For loan applications approved before 5 pm, the loan amount will be credited the same day to your account. For applications approved on holidays and weekends, the loan amount will be credited on the next working day. The sanction letter and T&Cs will be sent on your registered email ID" : "For loan applications submitted before 5 pm, the loan amount will be credited the same day to your account. For applications submitted on holidays and weekends, the loan amount will be credited on the next working day. The sanction letter and T&Cs has been sent on your registered email ID"}
                </div>
                <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  onClick={() => {
                    const currentURL = window.location.href;
                    const lastSlashIndex = currentURL.lastIndexOf("/");
                    const resultURL = currentURL.slice(0, lastSlashIndex);
                    window.location.replace(resultURL + "/index");
                  }}
                  text={"LOGOUT"}
                />
              </>
            )}
          </div>
        </LoanSummaryWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default LoanSummary;
